export default "__VITE_ASSET__D7LV5vUA__"